import React, { forwardRef } from "react";

const Input = forwardRef(({ name, placeholder, error, ...props }, ref) => {
  return (
    <div className={`form-group ${name}`}>
      <input
        ref={ref}
        className={`form-control ${error ? "error-field" : ""}`}
        type={name}
        placeholder={placeholder}
        {...props}
      />
      {error && (
        <span className="error">{error}</span>
      )}
    </div>
  );
});

export default Input;
